/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

import { INVITATION_FRAGMENT } from '../fragments'

export const BULK_SEND_INVITATIONS = gql`
  mutation BulkSendInvitations($data: [BulkInviteUserRowInput!]!) {
    bulkSendInvitations(data: $data) {
      ...Invitation
    }
  }
  ${INVITATION_FRAGMENT}
`
